export class Periode {
  forfait?: string;
  moyenneObservance?: number;
  dateDebut?: Date;
  dateFin?: Date;

  constructor(
    forfait?: string,
    moyenneObservance?: number,
    dateDebut?: Date,
    dateFin?: Date,
  ) {
    this.forfait = forfait;
    this.moyenneObservance = moyenneObservance;
    this.dateDebut = dateDebut;
    this.dateFin = dateFin;
  }

  static factory(periodeAPI: PeriodeAPI): Periode {
    return new Periode(
      periodeAPI.ForfaitLibelle,
      periodeAPI.MoyObservance,
      periodeAPI.DateDebut ? new Date(periodeAPI.DateDebut) : undefined,
      periodeAPI.DateFin ? new Date(periodeAPI.DateFin) : undefined,
    );
  }
}

export type PeriodeAPI = {
  ForfaitLibelle?: string;
  MoyObservance?: number;
  DateDebut?: string;
  DateFin?: string;
};